import { JDR } from '@/types/Interfaces';

export function createCharacter(type: JDR, name: string, playerId: string, gameId: string, isNPC: boolean) {
    const base = { name, isNPC, gameId, playerId, category: '' };

    switch (type) {
        case JDR.ParceDomine:
            return {
                ...base,
                token: { x: 0, y: 0, color: 'rgba(0, 0, 0, 0.8)' },
                stats: [
                    { name: 'health', current: 100, max: 100 },
                    { name: 'ri', current: 250, max: 250 },
                    { name: 'vigueur', current: 10, max: 10 },
                    { name: 'mental', current: 10, max: 10 },
                ],
                characteristics: [
                    { name: 'force', value: 10, color: 'green' },
                    { name: 'agilite', value: 10, color: 'green' },
                    { name: 'rapidite', value: 10, color: 'green' },
                    { name: 'parade', value: 10, color: 'green' },
                    { name: 'intuition', value: 10, color: 'purple' },
                    { name: 'volonte', value: 10, color: 'purple' },
                ],
                informations: [
                    { name: 'experience', value: 0 },
                    { name: 'age', value: 18 },
                    { name: 'taille', value: '1.80' },
                    { name: 'descriptionPhysique', value: '' },
                    { name: 'realName', value: name },
                    { name: 'poids', value: '70' },
                    { name: 'biographie', value: '' },
                    { name: 'categorieLueur', value: '' },
                    { name: 'sousCategorieLueur', value: '' },
                    { name: 'robustesse', value: 10 },
                    { name: 'physique', value: 10 },
                    { name: 'psychisme', value: 10 },
                    { name: 'lueur', value: 3 },
                    { name: 'descriptionLueur', value: '' },
                ],
            };

        case JDR.Azuria:
            return {
                ...base,
                token: { x: 0, y: 0, color: 'rgba(0, 0, 0, 0.8)' },
                inventory: { itemSlots: 10, items: [] },
                stats: [
                    { name: 'health', current: 30, max: 30 },
                ],
                characteristics: [
                    { name: 'agilite', value: 10, color: '#08086A' },
                    { name: 'constitution', value: 10, color: '#08086A' },
                    { name: 'force', value: 10, color: '#08086A' },
                    { name: 'intelligence/logique', value: 10, color: '#ECA101' },
                    { name: 'social', value: 10, color: '#ECA101' },
                    { name: 'temperance', value: 10, color: '#ECA101' },
                    { name: 'tir', value: 10, color: '#08086A' },
                    { name: 'volonte', value: 10, color: '#ECA101' },
                ],
                informations: [
                    { name: 'biographie', value: '' },
                    { name: 'race', value: 'automate' },
                    { name: 'ameliorations', value: '' },
                    { name: 'seuil de fatigue des ameliorations', value: 3 },
                    { name: 'Réput. Mondaine', value: 10 },
                ],
            };

        case JDR.Kimakaan:
            return {
                ...base,
                token: { x: 0, y: 0, color: 'rgba(0, 0, 0, 0.8)' },
                inventory: { itemSlots: 10, items: [] },
                stats: [
                    { name: 'health', current: 30, max: 30 },
                    { name: 'vigueur', current: 12, max: 12 },
                ],
                characteristics: [
                    { name: 'force brute', value: 10, color: '#87f8a8' },
                    { name: 'résistance', value: 10, color: '#87f8a8' },
                    { name: 'dextérité', value: 10, color: '#87f8a8' },
                    { name: 'célérité', value: 10, color: '#87f8a8' },
                    { name: 'alchimie', value: 10, color: '#ffe599' },
                    { name: 'forgeage', value: 10, color: '#ffe599' },
                    { name: 'récolte', value: 10, color: '#ffe599' },
                    { name: 'magie élémentaire', value: 10, color: '#8DD5F4' },
                    { name: 'sagesse', value: 10, color: '#8DD5F4' },
                    { name: 'ambition', value: 10, color: '#8DD5F4' },
                    { name: 'bravoure', value: 10, color: '#8DD5F4' },
                    { name: 'piété', value: 10, color: '#8DD5F4' },
                    { name: 'justice', value: 10, color: '#8DD5F4' },
                ],
                informations: [
                    { name: 'biographie', value: '' },
                    { name: 'ethnie', value: 'elfe' },
                    { name: 'religion', value: '' },
                    { name: 'classe', value: 'physique' },
                    { name: 'taille', value: 170 },
                    { name: 'description physique', value: '' },
                    { name: 'experience', value: 0 },
                    { name: 'majeure', value: 'résistance' },
                    { name: 'mineure', value: 'dextérité' },
                    { name: 'niveau majeure', value: 0 },
                    { name: 'niveau mineure', value: 0 },
                ],
            };

        case JDR.LandOfTheDread:
            return {
                ...base,
                token: { x: 0, y: 0, color: 'rgba(0, 0, 0, 0.8)', size: 1 },
                inventory: { itemSlots: 10, items: [] },
                stats: [
                    { name: 'health', current: 30, max: 30 },
                    { name: 'spirit', current: 5, max: 5 },
                    { name: 'vigueur', current: 12, max: 12 },
                ],
                characteristics: [
                    { name: 'force', value: 10, color: '#87f8a8' },
                    { name: 'agilité', value: 10, color: '#87f8a8' },
                    { name: 'rapidité', value: 10, color: '#87f8a8' },
                    { name: 'robustesse', value: 10, color: '#87f8a8' },
                    { name: 'perception', value: 10, color: '#ffe599' },
                    { name: 'visée', value: 10, color: '#ffe599' },
                ],
                informations: [
                    { name: 'nom', value: '' },
                    { name: 'classe', value: 'vampire' },
                    { name: 'biographie', value: '' },
                    { name: 'niveau', value: 1 },
                    { name: 'sous-classe', value: 'loup' },
                    { name: 'xp', value: 0 },
                ],
            };

        case JDR.ContesMacabres:
            return {
                ...base,
                token: { x: 0, y: 0, color: 'rgba(0, 0, 0, 0.8)' },
                inventory: { itemSlots: 6, items: [] },
                stats: [
                    { name: 'health', current: 6, max: 6 },
                    { name: 'vigueur', current: 10, max: 10 },
                ],
                characteristics: [
                    { name: 'attaque', value: 10, color: '#ff6363' },
                    { name: 'agilite', value: 10, color: '#ff6363' },
                    { name: 'robustesse', value: 10, color: '#ff6363' },
                    { name: 'rapidite', value: 10, color: '#ff6363' },
                    { name: 'perception', value: 10, color: '#80ff63' },
                    { name: 'visee', value: 10, color: '#80ff63' },
                    { name: 'savoir', value: 10, color: '#80ff63' },
                    { name: 'chance', value: 10, color: '#FFFFFF' },
                ],
                informations: [
                    { name: 'biographie', value: '' },
                    { name: 'niveau', value: '' },
                    { name: 'xp', value: '' },
                ],
            };

        default:
            return null;
    }
}
